import React, { Fragment, useState } from 'react';
import {
  fetchEnd,
  fetchStart,
  showNotification,
  crudGetList,
  required,
  TextInput,
  SelectInput
} from 'react-admin';
import {
  Grid,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Checkbox,
  Typography
} from '@material-ui/core';
import { connect } from 'react-redux';
import { FormSpy } from 'react-final-form';
import moment from 'moment';
import { DateInput } from '../../../core/components/forked/input/DateInput';
import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import { withStyles } from '@material-ui/core/styles';
import ResourceUploadApi from '../../../core/apis/ResourceUploadApi';
import DocumentApi from '../../../core/apis/DocumentApi';
import { documentStatus, documentFilterStatus } from '../ResourceUploadLookups';
import { SummaryActionBar } from '../uploadsteps/SummaryStep';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';
import { getIcError } from '../../../core/providers/utils';
import {
  formatDate,
  isValidDate,
  diff,
  Queue
} from '../../../core/utils/index';
import FormControl from '@material-ui/core/FormControl';
import Confirm from '../../../core/components/forked/layout/Confirm';
import VirtualizedGrid from '../../../core/components/VirtualizedGrid';
import setFieldTouched from 'final-form-set-field-touched';
import LightTooltip from '../../../core/components/LightTooltip';
import { sortBy } from 'lodash';
import CopyToInvestorStepper from './CopyToInvestorStepper';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const styles = () => ({
  checkbox: {
    marginLeft: '-12px',
    display: 'flex',
    paddingTop: '16px'
  },
  inputEllipsis: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  root: {
    margin: '0',
    '& > div': {
      border: '0px !important'
    }
  },
  dateRoot: {
    margin: '0',
    '& > div': {
      border: '0px !important',
      marginTop: '0px'
    }
  },
  statusRoot: {
    minWidth: '50px !important',
    margin: '0',
    '& > div': {
      border: '0px !important'
    }
  },
  gridCheckbox: {
    padding: '0'
  },
  columnClass: {
    minWidth: '150px'
  },
  headerClass: {
    paddingBottom: '8px'
  },
  summaryItemClass: {
    paddingRight: '16px'
  },
  button: {
    height: '30px',
    width: '80px',
    padding: '0px',
    marginLeft: '5px',
    background: 'white',
    border: '1px solid #E0E0E0',
    '& span': {
      padding: 0
    }
  },
  statusColumnClass: {
    minWidth: '110px'
  },
  dateColumnClass: {
    minWidth: '131px'
  },
  docGridLegend: {
    height: '30px',
    marginBottom: '5px',
    alignItems: 'flex-end'
  },
  paperWidthFalse: {
    height: 'inherit',
    width: '100%'
  },
  docGridLegendLabelClass: {
    fontSize: 14,
    fontWeight: 400,
    marginRight: '16px'
  },
  tableWrapper: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  infoIcon: {
    color: '#757575',
    paddingLeft: '6px'
  },
  gridButton: {
    fontSize: 14,
    fontWeight: 400,
    color: '#2962FF',
    marginRight: '16px',
    paddingTop: '2px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  dirty: {
    '& .MuiInputBase-root': {
      color: '#212121!important',
      fontWeight: 600,
      lineHeight: '20px'
    }
  },
  nonDirty: {
    '& .MuiInputBase-root': {
      fontWeight: 400,
      lineHeight: '20px'
    }
  },
  nonDirtyGrid: {
    'margin-top': '8px 8px 0 8px',
    '& .MuiInputBase-root': {
      fontWeight: 400,
      lineHeight: '20px'
    }
  },
  reviewContainer: {
    background: 'white',
    padding: '8px',
    border: '1px solid #E0E0E0',
    borderRadius: '2px',
    marginBottom: '8px',
    display: 'none'
  },
  reviewGridNewLabel: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px'
  },
  reviewGridOldLabel: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px'
  },
  simpleForm: {
    '& > div': {
      '& > div:first-of-type': {
        height: '0'
      }
    }
  }
});

export const EllipsisInput = withStyles({
  root: {
    '& .MuiInputBase-input': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    '& label + .MuiInput-formControl': {
      marginTop: '0px'
    }
  }
})(TextInput);

const ReadOnlyField = withStyles({
  root: {
    'margin-bottom': '16px',
    '& label': {
      color: '#757575!important',
      fontWeight: '600'
    },
    '& .MuiInputBase-root': {
      color: '#9E9E9E',
      border: 'transparent',
      background: 'transparent',
      fontWeight: '400',
      minHeight: '20px',
      'margin-top': '8px',
      'padding-left': 0,
      '&:before': {
        content: 'initial'
      }
    },
    '& .MuiInputBase-input': {
      padding: 0
    },
    '& .MuiFormHelperText-root': {
      color: '#9E9E9E',
      'margin-top': 0
    }
  }
})(TextInput);

const ReadOnlyFieldGrid = withStyles({
  root: {
    'box-sizing': 'border-box',
    'margin-bottom': '0',
    'padding-left': '8px',
    'margin-top': '0',
    '& label': {
      color: '#757575!important',
      fontWeight: '600'
    },
    '& .MuiInputBase-root': {
      color: '#9E9E9E',
      border: 'transparent',
      background: 'transparent',
      fontWeight: '400',
      fontSize: '12px',
      'margin-top': 0,
      'padding-left': 0,
      '&:before': {
        content: 'initial'
      }
    },
    '& .MuiInputBase-input': {
      padding: 0,
      textOverflow: 'ellipsis'
    },
    '& .MuiFormHelperText-root': {
      color: '#9E9E9E',
      'margin-top': 0,
      'margin-left': 0
    }
  }
})(TextInput);

const MAX_COUNTER = 50; // 50 * 5 sec = 4.16 min

const translateWatermarkRecordToInput = v => {
  if (v === null) {
    return 0;
  }
  return v;
};

const translateInvestorRecordToInput = (v, resourceupload, rowValue) => {
  //if no value for investorName we check investorId and if there is no investorId we assume it's fund level document
  if (!v) {
    if (!rowValue.investorId) {
      return 'All Investors';
    } else {
      return '';
    }
  }
  return v;
};

/**Validate the batch */
// const validateBatch = values => {
//   if (!values.resourceUploadTitle) {
//     return false;
//   }
//   if (!values.metadata.profileData.documentSecurityId) {
//     return false;
//   }
//   if (!values.metadata.documentDate) {
//     return false;
//   }
//   if (!values.metadata.profileData.categoryId) {
//     return false;
//   }
//   if (!values.metadata.documentTypeId) {
//     return false;
//   }

//   return true;
// };

/** The field is required if the batch was not uploaded via API */
const RequiredIfNotUploadedViaApi = (value, values) => {
  if (
    values &&
    values.resourceUpload &&
    values.resourceUpload.uploadVia === 'API'
  ) {
    return undefined;
  }
  if (!value) {
    return 'Required';
  }
};

/**
 * Downlaod existing batch and save file locally
 * @param fileName
 * @param documentId
 * @param fileName
 */
const downloadDocument = (documentId, fileName) => {
  DocumentApi.downloadDocumentAsFile(documentId, fileName);
};

const getTextFromValue = (id, lookup, isDate) => {
  if (id === null || id === undefined || id === '') return 'None';
  if (isDate) return moment(id).format('MM/DD/YYYY');
  if (!lookup) return id;
  var lookupObject = lookup.find(x => x.id === id);
  return lookupObject
    ? lookupObject.name || lookupObject.description || lookupObject.profileName
    : id;
};

const DocumentTable = withStyles(styles)(({ classes, ...props }) => {
  const {
    documents,
    resourceUpload,
    handleSelectAllClick,
    handleClick,
    handleGridAction,
    selectedRows,
    allWatermarks,
    allSecurities,
    allCategories,
    allSubCategories,
    dateHasError,
    handleDocumentDueDateChange,
    hasApprovePermission,
    hasDeletePermission,
    preview,
    formApi,
    validateTitle,
    setDocuments
  } = props;

  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

  const allColumns = [
    {
      id: 'Selected',
      source: 'isItemSelected',
      sortable: false,
      type: 'checkbox',
      width: 30,
      onClick: handleSelectAllClick,
      renderer: params => {
        const { row_data, rowVal } = params;
        const cellStyle = {
          ...row_data.style,
          color: '#000000',
          borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
          fontSize: '14px',
          background: 'white',
          padding: 0
        };
        const isItemSelected = selectedRows.indexOf(rowVal.id) !== -1;
        return (
          <div style={cellStyle} key={rowVal.id}>
            <Checkbox
              checked={isItemSelected}
              onClick={event => handleClick(event, rowVal.id)}
              className={classes.gridCheckbox}
            />
          </div>
        );
      }
    },
    {
      id: 'Document Title',
      source: 'documentTitle',
      sortable: true,
      type: 'input',
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            fontSize: '14px',
            fontWeight: '400',
            borderLeft: '1px solid #E0E0E0'
          };
          return (
            <LightTooltip
              placement="bottom"
              title={rowVal[column.source]}
              key={row_data.rowIndex}
            >
              <div style={cellStyle}>
                <EllipsisInput
                  source={`documents[${index}].${column.source}`}
                  label=""
                  className={classes.root}
                  variant="standard"
                  helperText={false}
                  validate={validateTitle}
                />
              </div>
            </LightTooltip>
          );
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          return (
            <ReviewGridField
              source={`documents[${index}].${column.source}`}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              row_data={row_data}
              isDate={false}
              lookup={undefined}
              value={rowVal[column.source]}
              style={cellStyle}
              hasNewValue={true}
              resourceUpload={resourceUpload}
            />
          );
        }
      }
    },
    {
      id: 'Investors',
      source: 'investorName',
      sortable: true,
      type: 'text',
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            fontSize: '14px',
            fontWeight: '400',
            textAlign: 'left',
            background: 'white',
            padding: '5px 8px 6px 8px',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          };
          return (
            <span style={cellStyle}>
              {rowVal['investorId'] ? rowVal[column.source] : 'All Investors'}
            </span>
          );
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          return (
            <ReviewGridField
              source={`documents[${index}].${column.source}`}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              row_data={row_data}
              isDate={false}
              lookup={undefined}
              value={rowVal[column.source]}
              style={cellStyle}
              hasNewValue={false}
              format={translateInvestorRecordToInput}
              resourceUpload={resourceUpload}
              rowValue={rowVal}
            />
          );
        }
      }
    },
    {
      id: 'Funds',
      source: 'fundName',
      sortable: true,
      type: 'text',
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            fontSize: '14px',
            fontWeight: '400',
            textAlign: 'left',
            background: 'white',
            padding: '5px 8px 6px 8px',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          };
          return <span style={cellStyle}>{rowVal[column.source]}</span>;
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          return (
            <ReviewGridField
              source={`documents[${index}].${column.source}`}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              row_data={row_data}
              isDate={false}
              lookup={undefined}
              value={rowVal[column.source]}
              style={cellStyle}
              hasNewValue={false}
              resourceUpload={resourceUpload}
            />
          );
        }
      }
    },
    {
      id: 'Category',
      source: 'categoryId',
      sortable: true,
      type: 'lookup',
      lookupTextField: 'name',
      lookupIdField: 'id',
      options: allCategories,
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            fontSize: '14px',
            textAlign: 'left',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            paddingLeft: '3px'
          };
          return (
            <SelectInput
              style={cellStyle}
              source={`documents[${index}].${column.source}`}
              choices={column.options}
              variant="standard"
              label=""
              optionText="name"
              optionValue="id"
              helperText={false}
              margin="none"
              onChange={() => {
                props.formApi.change(`documents[${index}].subcategoryId`, null);
              }}
              className={classes.root}
            />
          );
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          return (
            <ReviewGridField
              source={`documents[${index}].${column.source}`}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              row_data={row_data}
              isDate={false}
              lookup={allCategories}
              value={rowVal[column.source]}
              style={cellStyle}
              hasNewValue={true}
              resourceUpload={resourceUpload}
            />
          );
        }
      }
    },
    {
      id: 'Sub Category',
      source: 'subcategoryId',
      sortable: true,
      type: 'lookup',
      lookupTextField: 'name',
      lookupIdField: 'id',
      options: allSubCategories,
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            fontSize: '14px',
            textAlign: 'left',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            paddingLeft: '3px'
          };
          const availableSubCategory = column.options.filter(
            subCat => subCat.categoryId === rowVal.categoryId
          );
          if (availableSubCategory.length > 0) {
            return (
              <SelectInput
                style={cellStyle}
                source={`documents[${index}].${column.source}`}
                choices={availableSubCategory}
                variant="standard"
                label=""
                allowEmpty
                optionText="name"
                optionValue="id"
                helperText={false}
                margin="none"
                className={classes.root}
              />
            );
          } else {
            return <span style={cellStyle}></span>;
          }
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          return (
            <ReviewGridField
              source={`documents[${index}].${column.source}`}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              row_data={row_data}
              isDate={false}
              lookup={[
                {
                  name: 'None',
                  id: 0
                },
                ...allSubCategories
              ]}
              value={rowVal[column.source]}
              style={cellStyle}
              hasNewValue={true}
              resourceUpload={resourceUpload}
            />
          );
        }
      }
    },
    {
      id: 'Document Security',
      source: 'documentSecurityId',
      sortable: true,
      type: 'lookup',
      lookupTextField: 'description',
      lookupIdField: 'id',
      options: allSecurities,
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            fontSize: '14px',
            textAlign: 'left',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            paddingLeft: '3px'
          };
          return (
            <SelectInput
              style={cellStyle}
              source={`documents[${index}].${column.source}`}
              choices={column.options}
              variant="standard"
              label=""
              optionText="description"
              optionValue="id"
              helperText={false}
              margin="none"
              className={classes.root}
              onChange={() => {
                props.formApi.change(`documents[${index}].watermarkId`, null);
              }}
            />
          );
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          return (
            <ReviewGridField
              source={`documents[${index}].${column.source}`}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              row_data={row_data}
              isDate={false}
              lookup={allSecurities}
              value={rowVal[column.source]}
              style={cellStyle}
              hasNewValue={true}
              format={translateWatermarkRecordToInput}
              resourceUpload={resourceUpload}
            />
          );
        }
      }
    },
    {
      id: 'Watermark Profile',
      source: 'watermarkId',
      sortable: false,
      type: 'lookup',
      lookupTextField: 'profileName',
      lookupIdField: 'id',
      options: allWatermarks,
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            fontSize: '14px',
            textAlign: 'left',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            paddingLeft: '3px'
          };
          const docSecurity = allSecurities.find(
            sec => sec.id === rowVal.documentSecurityId
          );
          if (docSecurity && docSecurity.applyWatermark) {
            return (
              <SelectInput
                style={cellStyle}
                source={`documents[${index}].${column.source}`}
                choices={[
                  {
                    profileName: 'Default Profile',
                    id: 0
                  },
                  ...allWatermarks
                ]}
                variant="standard"
                label=""
                optionText="profileName"
                optionValue="id"
                helperText={false}
                margin="none"
                className={classes.root}
                allowEmpty={false}
                defaultValue={0}
                format={translateWatermarkRecordToInput}
              />
            );
          } else {
            return <span style={cellStyle}></span>;
          }
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          const docSecurity = allSecurities.find(
            sec => sec.id === rowVal.documentSecurityId
          );
          if (docSecurity && docSecurity.applyWatermark) {
            return (
              <ReviewGridField
                source={`documents[${index}].${column.source}`}
                dirtyFields={dirtyFields}
                classes={classes}
                formApi={formApi}
                variant={props.variant}
                row_data={row_data}
                isDate={false}
                lookup={[
                  {
                    profileName: 'Default Profile',
                    id: 0
                  },
                  ...allWatermarks
                ]}
                value={rowVal[column.source]}
                style={cellStyle}
                hasNewValue={true}
                format={translateWatermarkRecordToInput}
                resourceUpload={resourceUpload}
              />
            );
          } else {
            return <span style={cellStyle}></span>;
          }
        }
      }
    },
    {
      id: 'Document Date',
      source: 'documentDate',
      sortable: true,
      type: 'date',
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            fontSize: '14px',
            textAlign: 'left',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            paddingLeft: '3px'
          };
          return (
            <DateInput
              style={cellStyle}
              source={`documents[${index}].${column.source}`}
              label=""
              classes={{ root: classes.dateRoot }}
              validate={[required(), isValidDate]}
              customParseValue={formatDate}
              showFieldLabel={false}
            />
          );
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            paddingLeft: '6px'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          return (
            <ReviewGridField
              source={`documents[${index}].${column.source}`}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              row_data={row_data}
              isDate={true}
              lookup={undefined}
              value={rowVal[column.source]}
              style={cellStyle}
              hasNewValue={true}
              resourceUpload={resourceUpload}
            />
          );
        }
      }
    },
    {
      id: 'Document Due Date',
      source: 'dueDate',
      sortable: true,
      type: 'date',
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            fontSize: '14px',
            textAlign: 'left',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            paddingLeft: '3px'
          };
          return (
            <FormControl error style={cellStyle}>
              <DateInput
                source={`documents[${index}].${column.source}`}
                label=""
                classes={{ root: classes.dateRoot }}
                customParseValue={formatDate}
                onChange={value => {
                  handleDocumentDueDateChange(index, value);
                }}
                error={dateHasError[index]}
                helperText={false}
              />
            </FormControl>
          );
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          return (
            <ReviewGridField
              source={`documents[${index}].${column.source}`}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              row_data={row_data}
              isDate={true}
              lookup={undefined}
              value={rowVal[column.source]}
              style={cellStyle}
              hasNewValue={true}
              resourceUpload={resourceUpload}
            />
          );
        }
      }
    },
    {
      id: 'Document Status',
      source: 'status',
      sortable: true,
      type: 'status',
      options: documentFilterStatus,
      renderer: params => {
        const { column, row_data, rowVal } = params;
        const index = documents.findIndex(e => e.id === rowVal.id);
        if (!preview) {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            fontSize: '14px',
            textAlign: 'left',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
            paddingLeft: '3px'
          };
          return (
            <SelectInput
              style={cellStyle}
              source={`documents[${index}].${column.source}`}
              choices={documentFilterStatus}
              variant="standard"
              label=""
              helperText={false}
              optionText={<StatusColum record={rowVal} />}
              className={classes.statusRoot}
              disabled={!hasApprovePermission}
            />
          );
        } else {
          const cellStyle = {
            ...row_data.style,
            color: '#000000',
            background: 'white',
            borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0'
          };
          const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
          return (
            <ReviewGridField
              source={`documents[${index}].${column.source}`}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              row_data={row_data}
              isDate={false}
              lookup={documentFilterStatus}
              value={rowVal[column.source]}
              style={cellStyle}
              hasNewValue={true}
              resourceUpload={resourceUpload}
            />
          );
        }
      }
    },
    {
      id: 'File Name',
      source: 'originalFileName',
      type: 'link',
      sortable: true,
      renderer: params => {
        const { row_data, rowVal } = params;
        const cellStyle = {
          ...row_data.style,
          color: '#000000',
          fontWeight: '400',
          textAlign: 'left',
          padding: 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          borderTop: row_data.rowIndex === 1 ? 'none' : '1px solid #E0E0E0',
          fontSize: '14px',
          background: 'white'
        };
        return (
          <div style={cellStyle}>
            <Button
              onClick={() =>
                downloadDocument(rowVal.id, rowVal.originalFileName)
              }
              className={classes.gridButton}
            >
              {rowVal.originalFileName}
            </Button>
          </div>
        );
      }
    }
  ];
  //remove selection column in preview
  let columns = preview
    ? allColumns.filter(
        col =>
          col.source !== 'isItemSelected' && col.source !== 'originalFileName'
      )
    : hasDeletePermission
    ? allColumns
    : allColumns.filter(col => col.source !== 'isItemSelected');
  const noDocumentsMessage =
    resourceUpload.profileData.uploadType === 'BULK'
      ? 'There are no Documents to be displayed. Please complete splitting of the batch.'
      : 'There are no Documents to be displayed. Please assign the batch to Investors.';
  //add one row for columns with column names to grid data
  const columnRow = columns.reduce(
    (acc, cur) => ({ ...acc, [cur.source]: cur.id }),
    {}
  );
  let gridData = documents.slice();
  gridData = sortBy(gridData, 'order', 'asc');

  gridData.unshift(columnRow);

  const getGridHeight = (documents, resourceUpload, preview) => {
    let offSet = 230;
    if (HasSummaryActionBar(documents, resourceUpload, preview)) {
      offSet += 40;
    }
    if (!preview) {
      offSet += 140;
    }
    return `calc(100vh - ${offSet}px)`;
  };

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={12}>
        {!preview && (
          <Grid
            container
            wrap="nowrap"
            alignItems="center"
            justifyContent="space-between"
            className={classes.docGridLegend}
          >
            <Grid container item wrap="nowrap" alignItems="center">
              <span className={classes.docGridLegendLabelClass}>
                Batch ID:{' '}
                {resourceUpload ? resourceUpload.resourceUploadId : ''}
              </span>
              <span className={classes.docGridLegendLabelClass}>
                Number of documents in the Batch: {documents.length}
              </span>
              <span className={classes.docGridLegendLabelClass}>
                Uploaded By: {resourceUpload ? resourceUpload.uploadedBy : ''}
              </span>
            </Grid>
            {selectedRows.length > 0 && (
              <Fragment>
                <Button
                  classes={{ root: classes.button }}
                  variant="outlined"
                  color="primary"
                  value="delete"
                  onClick={() => setOpenConfirmDelete(true)}
                >
                  Delete
                </Button>
                <Confirm
                  isOpen={openConfirmDelete}
                  title="Delete Documents"
                  content="All selected documents will be permanently deleted."
                  onConfirm={() =>
                    handleGridAction('delete', setOpenConfirmDelete)
                  }
                  onClose={() => setOpenConfirmDelete(false)}
                />
                {!resourceUpload.allInvestors && selectedRows.length === 1 && (
                  <Button
                    classes={{ root: classes.button }}
                    variant="outlined"
                    color="primary"
                    value="assign"
                    onClick={() => {
                      handleGridAction('assign');
                    }}
                  >
                    Copy
                  </Button>
                )}
              </Fragment>
            )}
          </Grid>
        )}
        <Paper>
          {documents.length > 0 ? (
            <VirtualizedGrid
              columns={columns}
              data={gridData}
              fixedColumns={0}
              height={getGridHeight(documents, resourceUpload, preview)}
              minHeight="400px"
              rowHeight={preview ? 40 : 30}
              setDocuments={setDocuments}
            />
          ) : (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{ minHeight: '100px' }}
            >
              <Grid item>
                <Typography align="center">{noDocumentsMessage}</Typography>
              </Grid>
            </Grid>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
});

export const StatusColum = ({ record }) => {
  let colorObject = { color: orange[500] };
  if (record.id === 'SUSPENDED') {
    colorObject = { color: red[500] };
  } else if (record.id === 'ACTIVE') {
    colorObject = { color: green[500] };
  }
  return <span style={colorObject}>{record.name}</span>;
};

const ReviewField = props => {
  const {
    source,
    title,
    dirtyFields,
    classes,
    formApi,
    variant,
    lookup,
    isDate,
    format,
    multiline
  } = props;

  return (
    <ReadOnlyField
      label={title}
      className={dirtyFields[source] ? classes.dirty : classes.nonDirty}
      disabled={true}
      source={source}
      resource={props.resource}
      variant={variant}
      multiline={multiline}
      helperText={
        dirtyFields[source]
          ? getTextFromValue(
              formatValue(formApi.getFieldState(source).initial, format),
              lookup,
              isDate
            )
          : false
      }
      format={v => getTextFromValue(formatValue(v, format), lookup, isDate)}
    />
  );
};

const formatValue = (value, format, resourceUpload, rowData) => {
  if (format) {
    return format(value, resourceUpload, rowData);
  } else {
    return value;
  }
};

const ReviewGridField = props => {
  const {
    source,
    style,
    dirtyFields,
    classes,
    formApi,
    lookup,
    isDate,
    row_data,
    format,
    resourceUpload,
    rowValue
  } = props;
  return (
    <div style={style} key={row_data.key}>
      <ReadOnlyFieldGrid
        label=""
        className={dirtyFields[source] ? classes.dirty : classes.nonDirtyGrid}
        disabled={true}
        source={source}
        resource={props.resource}
        helperText={
          dirtyFields[source]
            ? getTextFromValue(
                formatValue(
                  formApi.getFieldState(source).initial,
                  format,
                  resourceUpload,
                  rowValue
                ),
                lookup,
                isDate
              )
            : false
        }
        format={v =>
          getTextFromValue(
            formatValue(v, format, resourceUpload, rowValue),
            lookup,
            isDate
          )
        }
      />
    </div>
  );
};

const EditGrid = props => {
  const {
    resourceUpload,
    documents,
    validateTitle,
    handleSelectAllClick,
    handleClick,
    handleProofActionChange,
    proofStatus,
    handleGridAction,
    allWatermarks,
    allSecurities,
    allCategories,
    allSubCategories,
    dateHasError,
    handleDocumentDueDateChange,
    hasApprovePermission,
    hasDeletePermission,
    preview,
    formApi,
    setDocuments,
    hasUnMatchedDocs
  } = props;
  const selectedRows = documents.reduce((selectedIds, document) => {
    if (document.selected) {
      selectedIds.push(document.id);
    }
    return selectedIds;
  }, []);
  return (
    <React.Fragment>
      <DocumentTable
        resourceUpload={resourceUpload}
        handleSelectAllClick={handleSelectAllClick}
        handleClick={handleClick}
        documents={documents}
        validateTitle={validateTitle}
        selectedRows={selectedRows}
        handleGridAction={handleGridAction}
        allWatermarks={allWatermarks}
        allSecurities={allSecurities}
        allCategories={allCategories}
        allSubCategories={allSubCategories}
        dateHasError={dateHasError}
        handleDocumentDueDateChange={handleDocumentDueDateChange}
        preview={preview}
        formApi={formApi}
        hasApprovePermission={hasApprovePermission}
        hasDeletePermission={hasDeletePermission}
        setDocuments={setDocuments}
      />
      {HasSummaryActionBar(documents, resourceUpload, preview) && (
        /* refactor to component and import */
        <SummaryActionBar
          handleProofActionChange={handleProofActionChange}
          proofStatus={proofStatus}
          bulkMode={true}
          hasUnMatchedDocs={hasUnMatchedDocs}
        />
      )}
    </React.Fragment>
  );
};

const HasSummaryActionBar = (documents, resourceUpload, preview) => {
  return (
    documents.length > 0 &&
    resourceUpload.profileData.uploadType === 'BULK' &&
    !preview
  );
};

const DetailsSummary = props => {
  const {
    classes,
    handleBatchTitleChange,
    onBatchStatusChange,
    batchLookups,
    useWatermark,
    subcategories,
    onBatchSecurityChange,
    onBatchColumnChange,
    onBatchCategoryChange,
    onBatchSubcategoryChange,
    hasApprovePermission,
    preview,
    formApi
  } = props;
  const dirtyFields = formApi ? formApi.getState().dirtyFields : {};
  return (
    <Grid container spacing={0}>
      <Grid xs={12} item className={classes.headerClass}>
        <span>
          {preview
            ? "Changes are highlighted in bold black font, while the original properties are gray. All changes will be applied after you press 'Save & Close' button."
            : 'Batch property changes will be applied to all documents in the batch. To make a change to a single document select the line item for the document that requires any change and make the appropriate selections.'}
        </span>
      </Grid>
      <Grid
        className={preview ? classes.reviewContainer : ''}
        container
        spacing={0}
      >
        <Grid item xs={12} sm={12} md={3} className={classes.summaryItemClass}>
          {preview ? (
            <ReviewField
              title="Batch Title"
              source="metadata.documentTitle"
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              multiline={true}
            />
          ) : (
            <TextInput
              label="Batch Title"
              source="metadata.documentTitle"
              resource={props.resource}
              options={{ autoComplete: 'off' }}
              variant={props.variant}
              validate={RequiredIfNotUploadedViaApi}
              multiline={true}
              onChange={event => {
                handleBatchTitleChange(event.target.value);
              }}
              helperText={false}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={3} className={classes.summaryItemClass}>
          {preview ? (
            <ReviewField
              title="Batch Status"
              source="metadata.batchStatus"
              lookup={documentStatus}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
              disabled={!hasApprovePermission}
            />
          ) : (
            <SelectInput
              source="metadata.batchStatus"
              choices={documentStatus}
              validate={[required()]}
              variant={props.variant}
              label="Batch Status"
              onChange={event => {
                onBatchStatusChange(event.target.value);
              }}
              helperText={false}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={3} className={classes.summaryItemClass}>
          {preview ? (
            <ReviewField
              title="Document Date"
              source="metadata.derivedInfo.derivedDocumentDate"
              isDate={true}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
            />
          ) : (
            <DateInput
              label="Document Date"
              source="metadata.derivedInfo.derivedDocumentDate"
              resource={props.resource}
              validate={[RequiredIfNotUploadedViaApi(), isValidDate]}
              placeholder="MM/dd/yyyy"
              customParseValue={formatDate}
              onChange={event => {
                onBatchColumnChange(
                  moment(event).format('YYYY-MM-DD'),
                  'documentDate',
                  `metadata.derivedInfo.derivedDocumentDate`
                );
                //set Due Date touched to true so validation error is displayed if any
                formApi.mutators.setFieldTouched(
                  'metadata.derivedInfo.derivedDueDate',
                  true
                );
              }}
              helperText={
                preview &&
                dirtyFields['metadata.derivedInfo.derivedDocumentDate']
                  ? formApi.getFieldState(
                      'metadata.derivedInfo.derivedDocumentDate'
                    ).initial
                  : false
              }
              disabled={preview}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          {preview ? (
            <ReviewField
              title="Due Date"
              source="metadata.derivedInfo.derivedDueDate"
              dirtyFields={dirtyFields}
              isDate={true}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
            />
          ) : (
            <DateInput
              label="Due Date"
              source="metadata.derivedInfo.derivedDueDate"
              resource={props.resource}
              placeholder="MM/dd/yyyy"
              validate={[isValidDate]}
              customParseValue={formatDate}
              onChange={event => {
                const value = event
                  ? moment(event).format('YYYY-MM-DD')
                  : event;
                onBatchColumnChange(
                  value,
                  'dueDate',
                  `metadata.derivedInfo.derivedDueDate`
                );
                //set Due Date touched to true so validation error is displayed if any
                formApi.mutators.setFieldTouched(
                  'metadata.derivedInfo.derivedDueDate',
                  true
                );
              }}
              helperText={false}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={3} className={classes.summaryItemClass}>
          {preview ? (
            <ReviewField
              title="Document Category"
              source="metadata.derivedInfo.derivedCategoryId"
              lookup={[
                ...batchLookups.allCategories,
                { id: 'MULTIPLE', name: 'Multiple Categories' }
              ]}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
            />
          ) : (
            <SelectInput
              source="metadata.derivedInfo.derivedCategoryId"
              label="Document Category"
              optionText="name"
              choices={[
                ...batchLookups.allCategories,
                { id: 'MULTIPLE', name: 'Multiple Categories', disabled: true }
              ]}
              allowEmpty
              onChange={event => {
                onBatchCategoryChange(event.target.value);
              }}
              variant={props.variant}
              helperText={false}
            />
          )}
        </Grid>
        {subcategories.length > 0 ? (
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            className={classes.summaryItemClass}
          >
            {preview ? (
              <ReviewField
                title="Subcategory"
                source="metadata.derivedInfo.derivedSubcategoryId"
                lookup={[
                  {
                    name: 'None',
                    id: 0
                  },
                  ...subcategories
                ]}
                dirtyFields={dirtyFields}
                classes={classes}
                formApi={formApi}
                variant={props.variant}
              />
            ) : (
              <SelectInput
                source="metadata.derivedInfo.derivedSubcategoryId"
                label="Subcategory"
                optionText="name"
                choices={[
                  ...subcategories,
                  {
                    id: 'MULTIPLE',
                    name: 'Multiple Subcategories',
                    disabled: true
                  }
                ]}
                allowEmpty
                onChange={event => {
                  onBatchSubcategoryChange(event.target.value);
                }}
                variant={props.variant}
                helperText={false}
              />
            )}
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            className={classes.summaryItemClass}
          ></Grid>
        )}
        <Grid item xs={12} sm={12} md={3} className={classes.summaryItemClass}>
          {preview ? (
            <ReviewField
              title="Security"
              source="metadata.derivedInfo.derivedDocumentSecurityId"
              lookup={batchLookups.allSecurities}
              dirtyFields={dirtyFields}
              classes={classes}
              formApi={formApi}
              variant={props.variant}
            />
          ) : (
            <SelectInput
              source="metadata.derivedInfo.derivedDocumentSecurityId"
              label="Security"
              optionText="description"
              choices={[
                ...batchLookups.allSecurities,
                {
                  id: 'MULTIPLE',
                  description: 'Multiple Securities',
                  disabled: true
                }
              ]}
              variant={props.variant}
              validate={RequiredIfNotUploadedViaApi}
              onChange={event => {
                onBatchSecurityChange(event.target.value);
              }}
              helperText={false}
              disabled={preview}
            />
          )}
        </Grid>
        {useWatermark ? (
          <Grid item xs={12} sm={12} md={3}>
            {preview ? (
              <ReviewField
                title="Watermark Profile"
                source="metadata.derivedInfo.derivedWatermarkProfileId"
                lookup={[
                  {
                    profileName: 'Default Profile',
                    id: 0
                  },
                  ...batchLookups.allWatermarks
                ]}
                dirtyFields={dirtyFields}
                classes={classes}
                formApi={formApi}
                variant={props.variant}
                format={translateWatermarkRecordToInput}
              />
            ) : (
              <SelectInput
                label="Watermark Profile"
                source="metadata.derivedInfo.derivedWatermarkProfileId"
                optionText="profileName"
                choices={[
                  {
                    profileName: 'Default Profile',
                    id: 0
                  },
                  ...batchLookups.allWatermarks,
                  {
                    id: 'MULTIPLE',
                    profileName: 'Multiple Watermarks',
                    disabled: true
                  }
                ]}
                allowEmpty={false}
                onChange={event => {
                  const newValue = event.target.value;
                  onBatchColumnChange(
                    newValue,
                    'watermarkId',
                    `metadata.profileData.watermarkId`
                  );
                }}
                variant={props.variant}
                defaultValue={0}
                format={translateWatermarkRecordToInput}
                helperText={false}
                disabled={preview}
              />
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={12} md={4}></Grid>
        )}
      </Grid>
    </Grid>
  );
};

class ManageDocumentPropertiesDialog extends React.Component {
  formApi;
  pristine;
  formValues = {};

  state = {
    useWatermark: false,
    subcategories: [],
    submitting: false,
    dateHasError: [],

    formIsDirty: false,
    previewVisible: false,
    formIsValid: true,
    copyToInvestorDialogOpen: false,
    copyToInvestorFundId: undefined,
    copyToInvestorExistingInvIds: [],
    copyToInvestorSourceDocument: undefined
  };

  isValidDate = value => {
    return (
      value &&
      moment(value).isValid() &&
      moment(value).isBetween('1900-01-01', '2079-06-06', undefined, '[]')
    );
  };

  handleDocumentDueDateChange = async (index, newValue) => {
    var newDateHasError = this.state.dateHasError;

    var isNewValueBlank = newValue === null;
    if (isNewValueBlank) {
      newDateHasError[index] = false;
      this.setState({
        dateHasError: newDateHasError
      });
      this.formApi.change(`documents[${index}].dueDate`, null);
      return;
    }

    if (!this.isValidDate(newValue) && !isNewValueBlank) {
      newDateHasError[index] = true;
      this.setState({
        dateHasError: newDateHasError
      });
      return;
    }

    if (newValue) {
      newDateHasError[index] = false;
      const newFormattedValue = moment(newValue)
        .startOf('day')
        .format('YYYY-MM-DDTHH:MM:SS.SSS');
      this.setState({
        dateHasError: newDateHasError
      });
      this.formApi.change(`documents[${index}].dueDate`, newFormattedValue);
    } else if (newDateHasError[index]) {
      newDateHasError[index] = false;
      this.setState({
        dateHasError: newDateHasError
      });
    }
  };

  handleCopyToInvestorDialogOpen = (selectedDocumentsIds, documents) => {
    const selectedDocument = documents.find(
      doc => doc.id === selectedDocumentsIds[0]
    );

    //get all existing investorIds from documents that are matched with fundId from selected document
    const alreadyMatchedInvestorIds = documents
      .filter(choice => choice.id === selectedDocumentsIds[0])
      .map(choice => choice.investorId);
    //TO DO  pass whole document so other properties can be used on second step
    if (selectedDocument) {
      // Update the selected document title with the batch title to make sure we keep the variable
      const documentToCopy = { ...selectedDocument };
      documentToCopy.documentTitle = this.formApi.getState().values.metadata.documentTitle;

      this.setState({
        copyToInvestorFundId: documentToCopy.fundId,
        copyToInvestorExistingInvIds: alreadyMatchedInvestorIds,
        copyToInvestorSourceDocument: documentToCopy
      });
      this.handleCopyToInvestorDialogOpenToggle();
    }
  };

  handleCopyToInvestorDialogOpenToggle = () => {
    this.setState(prevState => {
      return {
        copyToInvestorDialogOpen: !prevState.copyToInvestorDialogOpen
      };
    });
  };

  refreshAfterCopyToAnotherInvestors = newDocuments => {
    const formState = this.formApi.getState();
    const formValues = formState.values;

    this.formApi.reset({
      ...formState.initialValues,
      documents: formState.initialValues.documents.concat(newDocuments)
    }); // Concat the newly copied document to make sure they are part of the pristine fields

    this.formApi.change('documents', formValues.documents.concat(newDocuments));
  };

  componentDidMount() {
    const { batchForEdit = {} } = this.props;
    this.loadProofStatus(batchForEdit);
    const allSubcategories =
      batchForEdit.lookups && batchForEdit.lookups.allSubcategories
        ? batchForEdit.lookups.allSubcategories
        : [];
    this.setSubcategories(
      allSubcategories,
      batchForEdit.batch.derivedInfo.derivedCategoryId
    );
    this.setUseWatermark(
      batchForEdit.lookups,
      batchForEdit.batch.derivedInfo.derivedDocumentSecurityId === 'MULTIPLE'
        ? 'MULTIPLE'
        : parseInt(batchForEdit.batch.derivedInfo.derivedDocumentSecurityId),
      batchForEdit.batch.derivedInfo.derivedWatermarkProfileId,
      batchForEdit.documents
    );
    this.setDateHasError(this.props.batchForEdit.documents.length);
  }

  componentWillUnmount() {
    if (Queue) {
      Queue.stop = true;
    }
  }

  loadProofStatus = async batchForEdit => {
    if (
      batchForEdit.batch.profileData.uploadType === 'BULK' &&
      batchForEdit.documents.length > 0
    ) {
      this.proofStatusCheckHandler(true);
    }
  };

  setSubcategories = async (allSubcategories, categoryId) => {
    const subcategories =
      allSubcategories && allSubcategories.length > 0
        ? allSubcategories.filter(cat => cat.categoryId === categoryId)
        : [];
    this.setState({ subcategories: subcategories });
  };

  setDateHasError = async length => {
    var newDateHasError = [];
    for (var i = 0; i < length; i++) {
      newDateHasError.push(false);
    }
    this.setState({ dateHasError: newDateHasError });
  };

  searchBatchSecurity = (batchLookupsAllSec, item) => {
    return batchLookupsAllSec && batchLookupsAllSec.length > 0
      ? batchLookupsAllSec.find(sec => sec.id === item)
      : null;
  };

  checkWatermark(lookups, doc) {
    const batchSecurity = this.searchBatchSecurity(
      lookups.allSecurities,
      doc.documentSecurityId
    );
    return !batchSecurity.applyWatermark && !!doc.watermarkId;
  }

  setUseWatermark = (
    batchLookups,
    derivedSecurityId,
    derivedWatermarkId,
    batchDocuments
  ) => {
    let useWatermark = false;
    if (
      typeof derivedWatermarkId !== 'undefined' &&
      derivedWatermarkId !== null
    ) {
      useWatermark = true;
    } else if (derivedSecurityId !== 'MULTIPLE') {
      const batchSecurity = this.searchBatchSecurity(
        batchLookups.allSecurities,
        derivedSecurityId
      );
      useWatermark = batchSecurity && batchSecurity.applyWatermark;
    } else {
      // in case of multiple security profile as been selected on documents and stored on derived info
      // check directly on document if all the documents profile have watermark
      const documentsSecurityIds = [
        ...new Set(batchDocuments.map(item => item.documentSecurityId))
      ];
      useWatermark = !documentsSecurityIds.every(docSecId => {
        const batchSecurityModel = this.searchBatchSecurity(
          batchLookups.allSecurities,
          docSecId
        );
        return batchSecurityModel.applyWatermark === false;
      });
    }
    this.setState({ useWatermark: useWatermark });
  };

  /**
   *  Handle select all checbox clicked
   */
  handleSelectAllClick = event => {
    const { documents = [] } = this.formValues;
    const changedDocuments = documents.map(doc => {
      return { ...doc, selected: event.target.checked };
    });
    this.formApi.change(`documents`, changedDocuments);
  };

  /**
   *  Handle row checkbox clicked
   */
  handleClick = (event, id) => {
    const { documents = [] } = this.formValues;
    const index = documents.findIndex(document => document.id === id);
    if (index >= 0) {
      this.formApi.change(
        `documents[${index}].selected`,
        !documents[index].selected
      );
    }
  };

  handleProofActionChange = async value => {
    const { id } = this.props;

    switch (value) {
      case 'Generate':
        await this.handleProof(id);
        break;
      case 'Review':
        await this.downloadProofFile(id);
        break;
      default:
        break;
    }
  };

  handleProof = async resourceUploadId => {
    this.setState({ proofStatus: 'PROCESSING' });
    try {
      await ResourceUploadApi.proof(resourceUploadId);
      this.proofStatusCheckHandler(false);
    } catch (error) {
      this.setState({ proofStatus: 'ERROR' });
      this.props.showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(error) }
      });
    }
  };

  proofStatusCallback = async (batchProofStatus, initialProofCheck = false) => {
    const { proofStatus } = this.state;

    if (batchProofStatus) {
      const newProofStatus = batchProofStatus.status;
      //if proof status has changed
      if (proofStatus !== newProofStatus) {
        switch (newProofStatus) {
          case 'COMPLETED':
          case 'NOT_STARTED':
            Queue.stop = true;
            this.setState({ proofStatus: newProofStatus });
            break;
          case 'ERROR':
            Queue.stop = true;
            this.setState({ proofStatus: newProofStatus });
            //show error notification only if proof is triggered on this dialog; do not show on initial check
            if (!initialProofCheck) {
              this.props.showNotification(batchProofStatus.statusInfo, 'error');
            }
            break;
          case 'PROCESSING':
            this.setState({ proofStatus: newProofStatus });
            break;
          default:
            this.props.showNotification('Unknown proof status', 'error');
        }
      }
      //check if MAX_COUNT reached
      if (newProofStatus === 'PROCESSING' && Queue.queue.length === 0) {
        this.props.showNotification('Too many proof status requests', 'error');
      }
    }
  };

  //proof status promise with delay in ms
  proofStatusPromise = (resourceUploadId, ms, initialProofCheck) =>
    new Promise(resolve =>
      setTimeout(
        () => resolve(ResourceUploadApi.getProofStatus(resourceUploadId)),
        ms
      )
    )
      .then(result => {
        this.proofStatusCallback(result, initialProofCheck);
      })
      .catch(error => {
        const errorMessage = getIcError(error);
        const resultObject = { status: 'ERROR', statusInfo: errorMessage };
        this.proofStatusCallback(resultObject, initialProofCheck);
      });

  //add proof status promise to proof status queue
  callProofStatusDelay = (resourceUploadId, ms, initialProofCheck) => {
    Queue.enqueue(() =>
      this.proofStatusPromise(resourceUploadId, ms, initialProofCheck)
    );
  };

  /**
   * create promises queue for checking proofing status
   * @param {*} initialProofCheck - true if proof check is triggered on componenet initialization, false if manually triggered
   */
  proofStatusCheckHandler = initialProofCheck => {
    const { batchForEdit = {} } = this.props;
    const { resourceUploadId } = batchForEdit.batch;
    //add to status promise queue MAX_COUNTER number of check calls
    this.callProofStatusDelay(resourceUploadId, 0, initialProofCheck);
    for (var i = 0; i < MAX_COUNTER - 1; i++) {
      this.callProofStatusDelay(resourceUploadId, 5000, initialProofCheck);
    }
  };

  /**
   * Download the proof file and open it in a new tab
   */
  downloadProofFile = async resourceUploadId => {
    try {
      const response = await ResourceUploadApi.downloadProofFile(
        resourceUploadId
      );
      const url = window.URL.createObjectURL(response.data);
      window.open(url);
    } catch (error) {
      this.props.showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(error) }
      });
    }
  };

  /**
   * Check if newly selected value is the same as before
   * @param newValue
   * @param newValue
   * @param derivedProperty
   * @param derivedProperty
   */
  checkValueChanged = (newValue, source, derivedProperty = false) => {
    const { metadata } = this.formValues;
    return !(derivedProperty
      ? metadata.derivedInfo[source] === newValue
      : metadata[source] === newValue);
  };

  onBatchStatusChange = value => {
    const { documents = [] } = this.formValues;
    const statusChanged = this.checkValueChanged(value, 'batchStatus', false);
    if (!statusChanged) return;
    let docStatus;
    switch (value) {
      case 'A':
        docStatus = 'ACTIVE';
        break;
      case 'S':
        docStatus = 'SUSPENDED';
        break;
      case 'P':
        docStatus = 'PENDING';
        break;
      default:
        break;
    }

    if (documents.length > 0) {
      const changedDocuments = documents.map(document => {
        return { ...document, status: docStatus };
      });
      this.formApi.change(`documents`, changedDocuments);
    }
  };

  onBatchSecurityChange = value => {
    const securityChanged = this.checkValueChanged(
      value,
      'documentSecurityId',
      true
    );

    const { documents = [] } = this.formValues;
    if (!securityChanged) return;
    const { batchForEdit } = this.props;
    this.setUseWatermark(batchForEdit.lookups, value);
    if (documents.length > 0) {
      const changedDocuments = documents.map(doc => {
        return { ...doc, documentSecurityId: value, watermarkId: null };
      });
      this.formApi.batch(() => {
        this.formApi.change(
          `metadata.derivedInfo.derivedWatermarkProfileId`,
          null
        );
        this.formApi.change(`documents`, changedDocuments);
      });
    } else {
      this.formApi.change(
        `metadata.derivedInfo.derivedWatermarkProfileId`,
        null
      );
    }
  };

  //in the end this handler is only user for batch documentDate and dueDate from derivedInfo and watermarkId from profileData
  onBatchColumnChange = (value, documentsColumnName, batchPropertyName) => {
    const { documents = [] } = this.formValues;
    if (documents.length > 0) {
      const changedDocuments = documents.map(doc => {
        return { ...doc, [documentsColumnName]: value };
      });
      this.formApi.change(`documents`, changedDocuments);
    }
    this.formApi.change(batchPropertyName, value);
  };

  onBatchCategoryChange = value => {
    const { documents = [] } = this.formValues;
    const categoryChanged = this.checkValueChanged(value, 'categoryId', true);
    if (!categoryChanged) return;
    const { batchForEdit } = this.props;

    this.setSubcategories(batchForEdit.lookups.allSubcategories, value);
    if (documents.length > 0) {
      const changedDocuments = documents.map(doc => {
        return { ...doc, categoryId: value, subcategoryId: null };
      });

      this.formApi.batch(() => {
        this.formApi.change(`metadata.derivedInfo.derivedSubcategoryId`, null);
        this.formApi.change(`documents`, changedDocuments);
      });
    } else {
      this.formApi.change(`metadata.derivedInfo.derivedSubcategoryId`, null);
    }
  };

  onBatchSubcategoryChange = value => {
    const { documents = [] } = this.formValues;
    const categoryChanged = this.checkValueChanged(value, 'categoryId', true);
    if (!categoryChanged) return;

    if (documents.length > 0) {
      const changedDocuments = documents.map(doc => {
        return { ...doc, subcategoryId: value };
      });
      this.formApi.change(`documents`, changedDocuments);
    }
  };

  /**
   * Handle Batch Title Change
   */
  handleBatchTitleChange = newValue => {
    const { documents = [] } = this.formValues;
    this.formApi.change('resourceUploadTitle', newValue);

    if (documents.length > 0) {
      const changedDocuments = documents.map(doc => {
        return { ...doc, documentTitle: newValue };
      });
      this.formApi.change(`documents`, changedDocuments);
    }
  };

  // /**
  //  * Change investor ids selected documents
  //  */
  // handleMultipleDocumentsInvestorChange = newInvestorId => {
  //   const { documents = [] } = this.formValues;
  //   const { selectedDocumentsIds } = this.state;

  //   const changedDocuments = documents.map(document => {
  //     if (selectedDocumentsIds.includes(document.id)) {
  //       let changedDocument = { ...document };
  //       changedDocument.investorId = newInvestorId;
  //       changedDocument.fundId = 'MultiFund';
  //       return changedDocument;
  //     } else {
  //       return document;
  //     }
  //   });
  //   this.formApi.change(`documents`, changedDocuments);
  // };

  validateTitle = value => {
    if (!value) {
      return 'Required';
    }
    return undefined;
  };

  /**
   * Batch Dates validator
   */
  validateDates = values => {
    const errors = { metadata: { derivedInfo: {} } };
    if (
      values.metadata.derivedInfo.derivedDocumentDate &&
      values.metadata.derivedInfo.derivedDueDate
    ) {
      if (
        moment(values.metadata.derivedInfo.derivedDocumentDate).startOf(
          'day'
        ) >= moment(values.metadata.derivedInfo.derivedDueDate).startOf('day')
      ) {
        errors.metadata.derivedInfo.derivedDueDate =
          'Due Date must be after Document Date';
      }
    }
    return errors;
  };

  /**
   * Delete selected documents
   */
  deleteDocuments = async (documentIdsToDelete, documents) => {
    if (documentIdsToDelete.length > 0) {
      const body = documentIdsToDelete.map(documentId => {
        return { documentId: documentId, status: 'DELETED' };
      });

      try {
        await DocumentApi.deleteDocuments(body);
        let changedocuments = [...documents];
        changedocuments = changedocuments.filter(
          doc => !documentIdsToDelete.includes(doc.id)
        );

        //Also remove the document from the initial values of the documents
        const formState = this.formApi.getState();
        const docInitials = formState.initialValues.documents;
        const currentMetadata = formState.values.metadata;

        this.formApi.reset({
          ...formState.initialValues,
          documents: docInitials.filter(
            doc => !documentIdsToDelete.includes(doc.id)
          )
        });

        this.formApi.change('documents', changedocuments);
        //Keep metadata values set on a resource upload level, so they don't reset to initial ones after deleting document(s)
        this.formApi.change('metadata', currentMetadata);
      } catch (error) {
        this.props.showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      }
    }
  };

  //set order column value if sorting is clicked in underlying grid
  setDocuments = newDocuments => {
    const { documents = [] } = this.formValues;
    let changedDocuments = [...documents];
    if (documents.length > 0) {
      changedDocuments.forEach((document, index) => {
        document.order = newDocuments.findIndex(e => e.id === document.id);
      });
    }
    this.formApi.change('documents', changedDocuments);
  };

  handleGridAction = (type, confirmCloseHandler) => {
    if (confirmCloseHandler) {
      confirmCloseHandler(false);
    }
    let { documents = [] } = this.formValues;
    let selectedDocumentsIds = [];
    documents.forEach(document => {
      if (document.selected) {
        selectedDocumentsIds.push(document.id);
      }
    });
    switch (type) {
      case 'delete':
        this.deleteDocuments(selectedDocumentsIds, documents);
        break;
      case 'assign':
        this.handleCopyToInvestorDialogOpen(selectedDocumentsIds, documents);
        break;
      default:
        break;
    }
  };

  handleFormChange(formProps) {
    this.setState({ formIsDirty: formProps.dirty });
    this.setState({ formIsValid: formProps.valid });
  }

  //check if any of the batch properties has changed except batchStatus
  //also check if the batch was uploaded via api, in this case we submit only if all mandatory fields are properly populated
  checkBatchPropertiesChanged = () => {
    return false;

    // Return false for now as we do not save the batch for now
    // Todo put back the logic once bug on WL are solved
    /*
    const diffs = formState.dirtyFields;
    const formValues = formState.values;

    if (formValues.resourceUpload.uploadVia === 'API') {
      // For now we never allow to save a batch uploaded via API as the server side cannot handle missing values especially filename
      return false;
      // if (!validateBatch(formValues)) {
      //   // We consider the batch has not changed when is is not valid and uploaded via API
      //   return false;
      // }
    }

    //filter out batchStatus field since it's updated with separate API
    const changedBatchProps = Object.keys(diffs).filter(
      field => field.includes('metadata') && field !== 'metadata.batchStatus'
    );
    let hasChangeProps = false;
    if (changedBatchProps.length > 0) {
      //special case at the moment for subcategoryId since service returns 0 and form sends null if selected empty
      //should be changed on API to return null
      if (
        changedBatchProps.length === 1 &&
        changedBatchProps[0] === 'metadata.profileData.subcategoryId'
      ) {
        const initialValue = get(
          formState.initialValues,
          'metadata.profileData.subcategoryId',
          null
        );
        const currentValue = get(
          formState.values,
          'metadata.profileData.subcategoryId',
          null
        );
        if (
          initialValue !== currentValue &&
          !(
            (initialValue === 0 || initialValue == null) &&
            (currentValue === 0 || currentValue == null)
          )
        ) {
          hasChangeProps = true;
        }
      } else {
        hasChangeProps = true;
      }
    }
    return hasChangeProps;
    */
  };

  handleSaveChanges = formApi => {
    if (this.state.dateHasError.indexOf(true) > -1) return;
    formApi.submit();
  };

  handlePreviewVisibleChange = value => {
    if (this.state.formIsValid) {
      this.setState({ previewVisible: value });
    }
  };

  checkPreviewDisabled = api => {
    const diffs = diff(api.getState().values, api.getState().initialValues);
    return !(
      Object.keys(diffs).length !== 0 &&
      this.state.formIsValid &&
      this.state.dateHasError.indexOf(true) === -1
    );
  };

  undoChange = formApi => {
    formApi.reset();
    this.componentDidMount();
  };

  saveChanges = async values => {
    const { batchForEdit = {} } = this.props;
    const formState = this.formApi.getState();
    this.setState({ submitting: true });
    const { metadata, resourceUpload } = values;
    let profileData = { ...metadata.profileData };
    if (profileData.watermarkId === 0) {
      profileData.watermarkId = null; // 0 means default value and need to be replaced by null before saving
    }

    try {
      if (this.checkBatchPropertiesChanged(formState)) {
        const formBatchData = new FormData();
        let metadataValues = { ...metadata };

        formBatchData.append(
          'resourceUploadId',
          resourceUpload.resourceUploadId
        );
        formBatchData.append(
          'metadata',
          JSON.stringify({
            ...metadataValues,
            fileName: resourceUpload.fileName,
            quarter: resourceUpload.quarter,
            year: resourceUpload.year,
            fileType: resourceUpload.file && resourceUpload.file.rawFile.type,
            fundIds: resourceUpload.fundIds, // when update get fundIds and fundFamilyId from already existing resourceupload
            fundFamilyId: resourceUpload.fundFamilyId,
            allInvestors: resourceUpload.allInvestors,
            profileData: profileData
          })
        );
        await ResourceUploadApi.updateResourceUpload(formBatchData);
      }
      let batchStatusCalled = false;
      if (batchForEdit.batch.batchStatus !== values.metadata.batchStatus) {
        batchStatusCalled = true;
        await ResourceUploadApi.setBatchStatus(
          resourceUpload.resourceUploadId,
          values.metadata.batchStatus
        );
      }
      if (formState.values.documents.length > 0) {
        //get all changed documents
        const changedDocs = formState.values.documents.filter(
          doc => !formState.initialValues.documents.includes(doc)
        );
        let statusChangedDocs = []; //documents with changed status
        let fieldsChangedDocs = []; //documents with changed other fields than status
        changedDocs.forEach(document => {
          const initialValue = formState.initialValues.documents.find(
            d => d.id === document.id
          );
          //change condition when copy to investor option is added
          if (initialValue) {
            const differentFields = diff(initialValue, document);
            if (Object.keys(differentFields).indexOf('status') !== -1) {
              statusChangedDocs.push(document);
            }
            if (
              Object.keys(differentFields).findIndex(
                item => item !== 'status'
              ) !== -1
            ) {
              fieldsChangedDocs.push(document);
            }
          }
        });

        let documentsForUpdate = fieldsChangedDocs.map(doc => {
          const changeWatermark = this.checkWatermark(
            batchForEdit.lookups,
            doc
          );
          return changeWatermark || doc.watermarkId === 0
            ? { ...doc, watermarkId: null }
            : doc;
        });

        //if there is no investorId we assume it's fund level document and send '*' as investorId
        documentsForUpdate = documentsForUpdate.map(doc => {
          if (!doc.investorId) {
            return { ...doc, investorId: '*' };
          } else {
            return doc;
          }
        });

        if (documentsForUpdate && documentsForUpdate.length > 0) {
          await DocumentApi.assignDocuments(
            resourceUpload.resourceUploadId,
            documentsForUpdate
          );
        }

        const documentsForStatusUpdate = statusChangedDocs.map(doc => {
          return { documentId: doc.id, status: doc.status };
        });
        if (documentsForStatusUpdate && documentsForStatusUpdate.length > 0) {
          if (!batchStatusCalled) {
            // Only call document set status if batch set status was not call in this transaction to avoid double update of the status
            // and maker checker issue
            await DocumentApi.setMultipleStatus(documentsForStatusUpdate);
          }
        }
      }

      // Update title of the batch - if it was changed
      const isBatchTitleChanged = Object.keys(formState.dirtyFields).includes(
        'metadata.documentTitle'
      );
      if (isBatchTitleChanged) {
        const newBatchTitle = values.metadata.documentTitle;
        await ResourceUploadApi.updateResourceUploadTitle(
          resourceUpload.resourceUploadId,
          { resourceUploadTitle: newBatchTitle }
        );
      }

      this.setState({ submitting: false });
      this.props.showNotification('ra.notification.custom_updated_message');
      this.props.onClose();
    } catch (e) {
      this.setState({ submitting: false });
      this.props.showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(e) }
      });
    }
  };

  render() {
    const {
      showDialog,
      classes,
      onClose,
      batchForEdit,
      hasDeletePermission,
      permissions = []
    } = this.props;
    const hasApprovePermission = permissions.includes(
      'AUTH_APPROVE_RESOURCE_UPLOAD'
    );
    const batchLookups = batchForEdit.lookups;
    const {
      copyToInvestorDialogOpen,
      copyToInvestorFundId,
      copyToInvestorExistingInvIds,
      copyToInvestorSourceDocument
    } = this.state;
    return (
      <Dialog
        open={showDialog}
        aria-label={`Edit Properties`}
        maxWidth={false}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          onClose();
        }}
        classes={{
          paperWidthFalse: classes.paperWidthFalse // class name, e.g. `classes-nesting-root-x`
        }}
      >
        <DialogTitleWithCloseButton
          onClose={onClose}
          // help={
          //   'Batch property changes will be applied to all documents in the batch. To make a change to a single document select the line item for the document that requires any change and make the appropriate selections.'
          // }
        >
          Edit Properties
        </DialogTitleWithCloseButton>
        <DialogContent>
          <>
            {copyToInvestorDialogOpen && (
              <CopyToInvestorStepper
                showDialog={copyToInvestorDialogOpen}
                handleDialogToggle={this.handleCopyToInvestorDialogOpenToggle}
                handleRefresh={this.refreshAfterCopyToAnotherInvestors}
                fundId={copyToInvestorFundId}
                relatedInvestorIds={copyToInvestorExistingInvIds}
                sourceDocument={copyToInvestorSourceDocument}
                batchLookups={batchLookups}
              />
            )}
            <CustomSimpleForm
              toolbar={null}
              save={this.saveChanges}
              className={classes.simpleForm}
              resource="resourceuploads"
              variant="standard"
              margin="normal"
              mutators={{ setFieldTouched }}
              keepDirtyOnReinitialize={false}
              initialValues={{
                resourceUpload: batchForEdit.batch || {},
                resourceUploadTitle: batchForEdit.batch
                  ? batchForEdit.batch.documentTitle
                  : '',
                documents: batchForEdit.documents
                  ? batchForEdit.documents.filter(function(document) {
                      return (
                        document.matchingStatus !== 'INACTIVE_INVESTOR' &&
                        document.matchingStatus !== 'MISMATCH'
                      );
                    })
                  : [], // filter out documents with INACTIVE_INVESTOR and MISMATCH matchingStatus
                metadata: {
                  documentDate: batchForEdit.batch.documentDate,
                  dueDate: batchForEdit.batch.dueDate,
                  batchStatus: batchForEdit.batch.batchStatus,
                  documentTitle: batchForEdit.batch.documentTitle,
                  documentTypeId: batchForEdit.batch.documentTypeId,
                  documentProfileId: batchForEdit.batch.documentProfileId,
                  derivedInfo: batchForEdit.batch.derivedInfo,
                  profileData: batchForEdit.batch.profileData || {
                    uploadType: batchForEdit.batch.profileData.uploadType
                      ? 'BULK'
                      : 'SINGLE'
                  }
                }
              }}
              //in case state is changed prevent resetting values to initialValues
              initialValuesEqual={() => true}
              validate={this.validateDates}
            >
              <FormSpy
                subscription={{ dirty: true, valid: true }}
                onChange={formProps => this.handleFormChange(formProps)}
              />
              <FormSpy>
                {props => {
                  const {
                    proofStatus,
                    useWatermark,
                    subcategories
                  } = this.state;
                  this.formApi = props.form;
                  this.formValues = props.values;
                  const { documents = [], resourceUpload } = this.formValues;
                  const hasUnMatchedDocs =
                    batchForEdit.documents &&
                    batchForEdit.documents.findIndex(
                      doc => doc.matchingStatus === 'MISMATCH'
                    ) !== -1;
                  return (
                    <Fragment>
                      {this.state.previewVisible ? (
                        <Fragment>
                          <DetailsSummary
                            resourceUpload={resourceUpload}
                            classes={classes}
                            handleBatchTitleChange={this.handleBatchTitleChange}
                            onBatchStatusChange={this.onBatchStatusChange}
                            onResourceUploadPropertyChange={
                              this.onResourceUploadPropertyChange
                            }
                            batchLookups={batchLookups}
                            useWatermark={useWatermark}
                            subcategories={subcategories}
                            onBatchSecurityChange={this.onBatchSecurityChange}
                            onBatchColumnChange={this.onBatchColumnChange}
                            onBatchCategoryChange={this.onBatchCategoryChange}
                            onBatchSubcategoryChange={
                              this.onBatchSubcategoryChange
                            }
                            preview={this.state.previewVisible}
                            formApi={this.formApi}
                            hasApprovePermission={hasApprovePermission}
                            {...props}
                          />
                          <EditGrid
                            resourceUpload={resourceUpload}
                            documents={documents}
                            classes={classes}
                            allWatermarks={batchLookups.allWatermarks}
                            allSecurities={batchLookups.allSecurities}
                            allCategories={batchLookups.allCategories}
                            allSubCategories={batchLookups.allSubcategories}
                            preview={this.state.previewVisible}
                            formApi={this.formApi}
                            hasApprovePermission={hasApprovePermission}
                            hasDeletePermission={hasDeletePermission}
                            setDocuments={this.setDocuments}
                            {...props}
                          />
                        </Fragment>
                      ) : (
                        <Fragment>
                          <DetailsSummary
                            resourceUpload={resourceUpload}
                            classes={classes}
                            handleBatchTitleChange={this.handleBatchTitleChange}
                            onBatchStatusChange={this.onBatchStatusChange}
                            onResourceUploadPropertyChange={
                              this.onResourceUploadPropertyChange
                            }
                            batchLookups={batchLookups}
                            useWatermark={useWatermark}
                            subcategories={subcategories}
                            onBatchSecurityChange={this.onBatchSecurityChange}
                            onBatchColumnChange={this.onBatchColumnChange}
                            onBatchCategoryChange={this.onBatchCategoryChange}
                            onBatchSubcategoryChange={
                              this.onBatchSubcategoryChange
                            }
                            formApi={this.formApi}
                            preview={this.state.previewVisible}
                            hasApprovePermission={hasApprovePermission}
                            {...props}
                          />
                          <EditGrid
                            resourceUpload={resourceUpload}
                            documents={documents}
                            classes={classes}
                            handleClick={this.handleClick}
                            handleSelectAllClick={this.handleSelectAllClick}
                            handleProofActionChange={
                              this.handleProofActionChange
                            }
                            proofStatus={proofStatus}
                            validateTitle={this.validateTitle}
                            handleGridAction={this.handleGridAction}
                            allWatermarks={batchLookups.allWatermarks}
                            allSecurities={batchLookups.allSecurities}
                            allCategories={batchLookups.allCategories}
                            allSubCategories={batchLookups.allSubcategories}
                            dateHasError={this.state.dateHasError}
                            handleDocumentDueDateChange={
                              this.handleDocumentDueDateChange
                            }
                            formApi={this.formApi}
                            hasApprovePermission={hasApprovePermission}
                            hasDeletePermission={hasDeletePermission}
                            setDocuments={this.setDocuments}
                            hasUnMatchedDocs={hasUnMatchedDocs}
                          />
                        </Fragment>
                      )}
                    </Fragment>
                  );
                }}
              </FormSpy>
            </CustomSimpleForm>
          </>
        </DialogContent>
        <DialogActions>
          {this.state.previewVisible ? (
            <Fragment>
              <Button
                onClick={() => this.handlePreviewVisibleChange(false)}
                variant="outlined"
                color="primary"
                disabled={this.state.submitting}
              >
                Go Back To Edit Properties
              </Button>
              <Button
                onClick={() => this.handleSaveChanges(this.formApi)}
                color="primary"
                disabled={this.state.submitting}
                style={{ marginLeft: 'auto' }}
                variant="contained"
              >
                Save & Close
              </Button>
            </Fragment>
          ) : (
            <Fragment>
              <Button
                onClick={onClose}
                variant="outlined"
                color="primary"
                disabled={this.state.submitting}
              >
                Cancel
              </Button>
              <Button
                onClick={() => this.undoChange(this.formApi)}
                variant="text"
                color="primary"
                disabled={!this.state.formIsDirty}
              >
                Undo Changes
              </Button>
              <Button
                onClick={() => this.handlePreviewVisibleChange(true)}
                color="primary"
                disabled={
                  this.formApi ? this.checkPreviewDisabled(this.formApi) : false
                }
                style={{ marginLeft: 'auto' }}
                variant="contained"
              >
                Preview Changes
              </Button>
            </Fragment>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  crudGetList,
  fetchEnd,
  fetchStart,
  showNotification
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(ManageDocumentPropertiesDialog));
